<template>
<div>
  <form
    ref="form"
    data-url="/accreditationExecutive/directorLegalValidation/613"
    :class="{ 'loading-opacity': preloader }"
    enctype="multipart/form-data"
  >
    <div class="row">
      <div class="col-12">
        <legend class="col-form-label text-primary pt-0 mb-3">
          <h5>Evaluaciones</h5>
        </legend>
      </div>
      <div class="col-12">
        <table class="table table-sm table-striped">
          <thead>
            <tr>
              <th scope="col">Expediente</th>
              <th scope="col">Tipo</th>
              <th scope="col">Código</th>
              <th scope="col" class="text-center" style="width: 10%">
                Documento
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(value, key) in inputs.evaluations" :key="key">
              <td class="align-middle">
                {{ inputs.record }}
              </td>
              <td class="align-middle">
                <p v-if="value.type == 'E'">Evaluación</p>
                <p v-if="value.type == 'T'">Testificación</p>
              </td>
              <td class="align-middle">{{ value.code }}</td>
              <td class="align-middle text-center">
                <button
                  type="submit"
                  class="btn btn-success"
                  @click.prevent="openModal(value)"
                >
                  <app-icon name="file" />
                  {{ $t("view") }}
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <div class="row">
      <div class="col-12">
        <legend class="col-form-label text-primary pt-0 mb-3">
          <h5>Documentos</h5>
        </legend>
      </div>
      <div class="col-12">
        <table class="table table-sm table-striped">
          <thead>
            <tr>
              <th scope="col">TIPO</th>
              <th scope="col">NOMBRE</th>
              <th scope="col">FECHA</th>
              <th scope="col" class="text-center" style="width: 10%">ACCIÓN</th>
            </tr>
          </thead>
          <tbody>
            <tr v-if="inputs.request_signed">
              <td class="align-middle">Solicitud de acreditación firmada</td>
              <td class="align-middle">
                {{
                  inputs.request_signed
                    ? `${inputs.request_signed.user.full_name}`
                    : ""
                }}
              </td>
              <td class="align-middle">
                {{
                  inputs.request_signed
                    ? `${inputs.request_signed.created_at}`
                    : "" | dateFormat
                }}
              </td>
              <td class="align-middle text-center">
                <button
                  type="submit"
                  class="btn btn-success"
                  @click.prevent="openTab(inputs, 'request_signed')"
                >
                  <app-icon name="file" />
                  {{ $t("view") }}
                </button>
              </td>
            </tr>
            <tr v-if="inputs.request_signed">
              <td class="align-middle">
                Anexos de la Solicitud de Acreditación
              </td>
              <td class="align-middle">
                {{
                  inputs.user
                    ? `${inputs.user.first_name} ${inputs.user.last_name}`
                    : ""
                }}
              </td>
              <td class="align-middle">
                {{ inputs.created_at | dateFormat }}
              </td>
              <td class="align-middle text-center">
                <a
                  class="btn btn-success"
                  :href="`/accreditations/applications/${inputs.id}?tab=Anexos`"
                  target="_blank"
                  ><app-icon name="file" /> {{ $t("view") }}</a
                >
              </td>
            </tr>
            <tr v-if="inputs.receipt_return_report"> 
              <td class="align-middle">
                Registro de Ingreso de solicitud de acreditación y acuse recibo
              </td>
              <td class="align-middle">
                {{
                  inputs.receipt_return_report
                    ? `${inputs.receipt_return_report.user.full_name}`
                    : ""
                }}
              </td>
              <td class="align-middle">
                {{
                  inputs.receipt_return_report
                    ? `${inputs.receipt_return_report.created_at}`
                    : "" | dateFormat
                }}
              </td>
              <td class="align-middle text-center">
                <button
                  type="submit"
                  class="btn btn-success"
                  @click.prevent="openTab(inputs, 'receipt_return_report')"
                >
                  <app-icon name="file" />
                  {{ $t("view") }}
                </button>
              </td>
            </tr>

            <tr v-if="inputs.technical_file_analysis_report">
              <td class="align-middle">
                Informe Técnico de Análisis de Expediente y de Toma de Decisión
              </td>
              <td class="align-middle">
                {{
                  inputs.technical_file_analysis_report
                    ? `${inputs.technical_file_analysis_report.user.full_name}`
                    : ""
                }}
              </td>
              <td class="align-middle">
                {{
                  inputs.technical_file_analysis_report
                    ? `${inputs.technical_file_analysis_report.created_at}`
                    : "" | dateFormat
                }}
              </td>
              <td class="align-middle text-center">
                <button
                  type="submit"
                  class="btn btn-success"
                  @click.prevent="
                    openTab(inputs, 'technical_file_analysis_report')
                  "
                >
                  <app-icon name="file" />
                  {{ $t("view") }}
                </button>
              </td>
            </tr>

            <!-- <tr>
              <td class="align-middle">Anexo de plan de mantenimiento</td>
              <td class="align-middle">
                {{
                  inputs.maintenance_plan
                    ? `${inputs.maintenance_plan.user.full_name}`
                    : ""
                }}
              </td>
              <td class="align-middle">
                {{
                  inputs.maintenance_plan
                    ? `${inputs.maintenance_plan.created_at}`
                    : "" | dateFormat
                }}
              </td>
              <td class="align-middle text-center">
                <button
                  type="submit"
                  class="btn btn-success"
                  @click.prevent="openTab(inputs, 'maintenance_plan')"
                >
                  <app-icon name="file" />
                  {{ $t("view") }}
                </button>
              </td>
            </tr> -->


           <!-- <tr v-for="(value, key) in documents" :key="key+200">
                <template v-if="value.status.code ==='605'">
                <td class="align-middle">{{ value.status.name }}</td>
                <td class="align-middle">
                  {{ value.from_user.full_name }}
                </td>
                <td class="align-middle">
                  {{ value.report_date | dateFormat }} -->
                  <!--{{ docs.area_director_report.created_at | dateFormat }}-->
                <!-- </td>
                <td class="align-middle text-center">
                  <button
                    type="submit"
                    class="btn btn-success"
                    @click.prevent="openTabInfo(value.accreditation_id, 605)"
                  > -->
                    <!-- @click.prevent="openTabInfo(docs, 'area_director_report')" -->
                    <!-- <app-icon name="file" />
                    {{ $t("view") }}
                  </button>
                </td>
                </template>
              </tr> -->


            <!--<tr>
              <td class="align-middle">
                Evidencia de participación de los miembros de la comisión
              </td>
              <td class="align-middle">
                {{
                  inputs.evidence_member_participation
                    ? `${inputs.evidence_member_participation.user.full_name}`
                    : ""
                }}
              </td>
              <td class="align-middle">
                {{
                  inputs.evidence_member_participation
                    ? `${inputs.evidence_member_participation.created_at}`
                    : "" | dateFormat
                }}
              </td>

              <td class="align-middle text-center">
                <button
                  type="submit"
                  class="btn btn-success"
                  @click.prevent="
                    openTab(inputs, 'evidence_member_participation')
                  "
                >
                  <app-icon name="file" />
                  {{ $t("view") }}
                </button>
              </td>
            </tr>

            <tr>
              <td class="align-middle">Informe Director de Área</td>
              <td class="align-middle">
                {{
                  inputs.area_director_report
                    ? `${inputs.area_director_report.user.full_name}`
                    : ""
                }}
              </td>
              <td class="align-middle">
                {{
                  inputs.area_director_report
                    ? `${inputs.area_director_report.created_at}`
                    : "" | dateFormat
                }}
              </td>
              <td class="align-middle text-center">
                <button
                  type="submit"
                  class="btn btn-success"
                  @click.prevent="openTab(inputs, 'area_director_report')"
                >
                  <app-icon name="file" />
                  {{ $t("view") }}
                </button>
              </td>
            </tr> -->
              <tr v-for="(value, key) in documents" :key="key+300">
                <template v-if="value.status.code ==='608'">
                <td class="align-middle">{{ value.status.name }}</td>
                <td class="align-middle">
                  {{ value.from_user.full_name }}
                </td>
                <td class="align-middle">
                  {{ value.report_date | dateFormat }}
                  <!--{{ docs.area_director_report.created_at | dateFormat }}-->
                </td>
                <td class="align-middle text-center">
                  <button
                    type="submit"
                    class="btn btn-success"
                    @click.prevent="openTabInfo(value.accreditation_id, 608)"
                  >
                    <!-- @click.prevent="openTabInfo(docs, 'area_director_report')" -->
                    <app-icon name="file" />
                    {{ $t("view") }}
                  </button>
                </td>
                </template>
              </tr>

            <!--<tr>
              <td class="align-middle">
                Informe Coordinación General Técnica
              </td>
              <td class="align-middle">
                {{
                  inputs.general_technical_coordination_report
                    ? `${inputs.general_technical_coordination_report.user.full_name}`
                    : ""
                }}
              </td>
              <td class="align-middle">
                {{
                  inputs.general_technical_coordination_report
                    ? `${inputs.general_technical_coordination_report.created_at}`
                    : "" | dateFormat
                }}
              </td>
              <td class="align-middle text-center">
                <button
                  type="submit"
                  class="btn btn-success"
                  @click.prevent="
                    openTabInfo(inputs.id, 609)
                  "
                >

                  <app-icon name="file" />
                  {{ $t("view") }}
                </button>
              </td>
            </tr> -->
              <tr v-for="(value, key) in documents" :key="key+100">
                <template v-if="value.status.code ==='609'">
                <td class="align-middle">{{ value.status.name }}</td>
                <td class="align-middle">
                  {{ value.from_user.full_name }}
                </td>
                <td class="align-middle">
                  {{ value.report_date | dateFormat }}
                  <!--{{ docs.area_director_report.created_at | dateFormat }}-->
                </td>
                <td class="align-middle text-center">
                  <button
                    type="submit"
                    class="btn btn-success"
                    @click.prevent="openTabInfo(value.accreditation_id, 609)"
                  >
                    <!-- @click.prevent="openTabInfo(docs, 'area_director_report')" -->
                    <app-icon name="file" />
                    {{ $t("view") }}
                  </button>
                </td>
                </template>
              </tr>


              <tr v-for="(value, key) in documents" :key="key">
                <template v-if="value.status.code ==='610'">
                <td class="align-middle">{{ value.status.name }}</td>
                <td class="align-middle">
                  {{ value.from_user.full_name }}
                </td>
                <td class="align-middle">
                  {{ value.report_date | dateFormat }}
                  <!--{{ docs.area_director_report.created_at | dateFormat }}-->
                </td>
                <td class="align-middle text-center">
                  <button
                    type="submit"
                    class="btn btn-success"
                    @click.prevent="openTabInfo(value.accreditation_id, 610)"
                  >
                    <!-- @click.prevent="openTabInfo(docs, 'area_director_report')" -->
                    <app-icon name="file" />
                    {{ $t("view") }}
                  </button>
                </td>
                </template>
              </tr>


            <!--<tr>
              <td class="align-middle">Borrador Informe Jurídico</td>
              <td class="align-middle">
                {{
                  inputs.legal_report
                    ? `${inputs.legal_report.user.full_name}`
                    : ""
                }}
              </td>
              <td class="align-middle">
                {{
                  inputs.legal_report
                    ? `${inputs.legal_report.created_at}`
                    : "" | dateFormat
                }}
              </td>
              <td class="align-middle text-center">
                <button
                  type="submit"
                  class="btn btn-success"
                  @click.prevent="
                    openTabInfo(inputs.id, 610)
                    
                  "
                >
                  <app-icon name="file" />
                  {{ $t("view") }}
                </button>
              </td>
            </tr> -->
            <tr>
              <td class="align-middle">Borrador Resolución</td>
              <td class="align-middle">
                {{
                  inputs.draft_resolution
                    ? `${inputs.draft_resolution.user.full_name}`
                    : ""
                }}
              </td>
              <td class="align-middle">
                {{
                  inputs.draft_resolution
                    ? `${inputs.draft_resolution.created_at}`
                    : "" | dateFormat
                }}
              </td>
              <td class="align-middle text-center">
                <button
                  type="submit"
                  class="btn btn-success"
                  @click.prevent="openTab(inputs, 'draft_resolution')"
                >
                  <app-icon name="file" />
                  {{ $t("view") }}
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div
        class="col-12"
        v-if="inputs.additional_605 && inputs.additional_605.length > 0"
      >
        <legend class="col-form-label text-primary pt-0 mb-3">
          <h5>
            <b>(Reunión de la Comisión de Acreditación):</b> Documentos
            adicionales para subsanar o complementar el proceso
          </h5>
        </legend>
        <table
          class="table table-sm table-striped"
          v-if="inputs.additional_605 && inputs.additional_605.length > 0"
        >
          <thead>
            <tr>
              <th scope="col">OBSERVACIÓN</th>
              <th scope="col">NOMBRE</th>
              <th scope="col">FECHA</th>
              <th scope="col" class="text-center" style="width: 10%">ACCIÓN</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(value, key) in inputs.additional_605" :key="key">
              <td class="align-middle">{{ value.filename }}</td>
              <td class="align-middle">
                {{ value.annexed.user.full_name }}
              </td>
              <td class="align-middle">
                {{ value.annexed.created_at | dateFormat }}
              </td>
              <td class="align-middle text-center">
                <button
                  type="submit"
                  class="btn btn-success"
                  @click.prevent="
                    openTab(inputs, 'additional_605', value.annexed.path)
                  "
                >
                  <app-icon name="file" />
                  {{ $t("view") }}
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div
        class="col-12"
        v-if="inputs.additional_608 && inputs.additional_608.length > 0"
      >
        <legend class="col-form-label text-primary pt-0 mb-3">
          <h5>
            <b>(Informe Director de Área):</b> Documentos adicionales para
            subsanar o complementar el proceso
          </h5>
        </legend>
        <table
          class="table table-sm table-striped"
          v-if="inputs.additional_608 && inputs.additional_608.length > 0"
        >
          <thead>
            <tr>
              <th scope="col">OBSERVACIÓN</th>
              <th scope="col">NOMBRE</th>
              <th scope="col">FECHA</th>
              <th scope="col" class="text-center" style="width: 10%">ACCIÓN</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(value, key) in inputs.additional_608" :key="key">
              <td class="align-middle">{{ value.filename }}</td>
              <td class="align-middle">
                {{ value.annexed.user.full_name }}
              </td>
              <td class="align-middle">
                {{ value.annexed.created_at | dateFormat }}
              </td>
              <td class="align-middle text-center">
                <button
                  type="submit"
                  class="btn btn-success"
                  @click.prevent="
                    openTab(inputs, 'additional_608', value.annexed.path)
                  "
                >
                  <app-icon name="file" />
                  {{ $t("view") }}
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div
        class="col-12"
        v-if="inputs.additional_609 && inputs.additional_609.length > 0"
      >
        <legend class="col-form-label text-primary pt-0 mb-3">
          <h5>
            <b>(Informe Coordinación General Técnica):</b> Documentos
            adicionales para subsanar o complementar el proceso
          </h5>
        </legend>
        <table
          class="table table-sm table-striped"
          v-if="inputs.additional_609 && inputs.additional_609.length > 0"
        >
          <thead>
            <tr>
              <th scope="col">OBSERVACIÓN</th>
              <th scope="col">NOMBRE</th>
              <th scope="col">FECHA</th>
              <th scope="col" class="text-center" style="width: 10%">ACCIÓN</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(value, key) in inputs.additional_609" :key="key">
              <td class="align-middle">{{ value.filename }}</td>
              <td class="align-middle">
                {{ value.annexed.user.full_name }}
              </td>
              <td class="align-middle">
                {{ value.annexed.created_at | dateFormat }}
              </td>
              <td class="align-middle text-center">
                <button
                  type="submit"
                  class="btn btn-success"
                  @click.prevent="
                    openTab(inputs, 'additional_609', value.annexed.path)
                  "
                >
                  <app-icon name="file" />
                  {{ $t("view") }}
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div
        class="col-12"
        v-if="inputs.additional_610 && inputs.additional_610.length > 0"
      >
        <legend class="col-form-label text-primary pt-0 mb-3">
          <h5>
            <b>(Elaboración de Informe Jurídico para la Acreditación):</b>
            Documentos adicionales para subsanar o complementar el proceso
          </h5>
        </legend>
        <table
          class="table table-sm table-striped"
          v-if="inputs.additional_610 && inputs.additional_610.length > 0"
        >
          <thead>
            <tr>
              <th scope="col">OBSERVACIÓN</th>
              <th scope="col">NOMBRE</th>
              <th scope="col">FECHA</th>
              <th scope="col" class="text-center" style="width: 10%">ACCIÓN</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(value, key) in inputs.additional_610" :key="key">
              <td class="align-middle">{{ value.filename }}</td>
              <td class="align-middle">
                {{ value.annexed.user.full_name }}
              </td>
              <td class="align-middle">
                {{ value.annexed.created_at | dateFormat }}
              </td>
              <td class="align-middle text-center">
                <button
                  type="submit"
                  class="btn btn-success"
                  @click.prevent="
                    openTabInfo(inputs, 'additional_610', value.annexed.path)
                  "
                >
                  <app-icon name="file" />
                  {{ $t("view") }}
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <br />

    <div class="row">
      <!--<div class="col-6">
        <div class="form-group">
          <label>Informe Jurídico <b class="text-danger">*</b></label>
          <app-input
            type="file"
            :label="inputs.file_1 ? inputs.file_1.name : $t('upload_your_file')"
            v-model="inputs.file_1"
            v-if="!inputs.legal_report_director"
          />
          <div class="mt-2">
            <button
              type="submit"
              class="btn btn-success"
              @click.prevent="openTab(inputs, 'legal_report_director')"
              v-if="inputs.legal_report_director"
            >
              <app-icon name="file" />
              {{ $t("view") }}
            </button>

            <button
              type="submit"
              class="btn btn-danger"
              @click.prevent="openDeleteModal('legal_report_director')"
              v-if="inputs.legal_report_director"
            >
              <app-icon name="trash-2" />
              {{ $t("delete") }}
            </button>
          </div>
        </div>
      </div> -->
      <div class="col-6">
        <div class="form-group">
          <label>Resolución <b class="text-danger">*</b></label>
          <app-input
            type="file"
            :label="inputs.file_2 ? inputs.file_2.name : $t('upload_your_file')"
            v-model="inputs.file_2"
            v-if="!inputs.legal_resolution_director"
          />
          <div class="mt-2">
            <button
              type="submit"
              class="btn btn-success"
              @click.prevent="openTab(inputs, 'legal_resolution_director')"
              v-if="inputs.legal_resolution_director"
            >
              <app-icon name="file" />
              {{ $t("view") }}
            </button>

            <button
              type="submit"
              class="btn btn-danger"
              @click.prevent="openDeleteModal('legal_resolution_director')"
              v-if="inputs.legal_resolution_director"
              :disabled="status"
            >
              <app-icon name="trash-2" />
              {{ $t("delete") }}
            </button>
          </div>
        </div>
      </div>
    </div>

    <br />

    <!-- <div class="row">
      <div class="col-12">
        <legend class="col-12 col-form-label text-primary pt-0 mb-3">
          <h5>Documentos Adicionales</h5>
        </legend>
      </div>
      <div class="col-12 text-center">
          <app-input type="dropzone" v-model="dropzone_files_legal" />
      </div>
    </div>

    <div class="row">
      <div class="col-12 mt-3">
        <button
          type="submit"
          class="btn btn-primary mr-2"
          @click.prevent="submit"
        >
          {{ $t("save") }}
        </button>
      </div>
    </div> -->

    <div class="row">
      <div class="col-12 mt-3">
        <button
          type="submit"
          class="btn btn-primary mr-2"
          @click.prevent="submit"
          :disabled="status"
        >
          {{ $t("save") }}
        </button>
      </div>
    </div>

    <!-- <legal-validation-613-annexes-modal
      v-if="isAddEditModalActive"
      selected-url=""
      @close-modal="closeAddEditModal"
    /> -->
    <director-area-modal
      v-if="isAddEditModalActive"
      :selected-url="selectedUrl"
      @close-modal="closeAddEditModal"
    />

    <app-confirmation-modal
      v-if="deleteModal"
      modal-id="delete"
      @confirmed="confirmed"
      @cancelled="cancelled"
      title="Confirmación"
      message="¿Desea eliminar este archivo?"
    />
  </form>
<br><br>
<div class="row">
  <div class="col-12">
 <legend class="col-form-label text-primary pt-0 mb-3">
          <h5> <b>
            Informe Jurídico
            </b>
          </h5>
        </legend>

          <legend>
            <p class="text-primary"><small> Cabecera del informe </small></p>
          </legend>

          <div class="row">
            <div class="col-sm">
              <div class="form-group">
                <label class="mb-0">Nº Memorando: </label>
                <app-input
                  type="text"
                  v-model="inputsInform.memorando"
                  placeholder="Ingrese el número de memorando"
                  :required="true"
                  :disabled="true"
                />
              </div>
            </div>
            <div class="col-sm">
              <div class="form-group">
                <label class="mb-0">Fecha de documento: </label>
                <app-input
                  type="date"
                  v-model="inputsInform.report_date"
                  placeholder="Ingrese la fecha del documento."
                  :required="true"
                  :disabled="true"
                />
              </div>
            </div> 
          </div>
          <!--<div class="row">
            <div class="col-sm">
              <div class="form-group">
                <label class="mb-0">De: </label>
                <app-input
                  type="text"
                  v-model="full_name_from"
                  :disabled="true"
                />
              </div>
            </div>

            <div class="col-sm">
              <div class="form-group">
                <label class="mb-0">Para: </label>
                <app-input
                  type="text"
                  v-model="full_name_to"
                  :disabled="true"
                  v-if="full_name_to"
                />
              </div>
            </div> 
          </div>-->

          <div class="row">
            <div class="col-sm">
              <div class="form-group">
                <label class="mb-0">Asunto: </label>
                <app-input
                  type="text"
                  v-model="inputsInform.matter"
                  placeholder="Ingrese el asunto"
                  :required="true"
                  :disabled="status"
                />
              </div>
            </div>
          </div>

          <legend>
            <p class="text-primary"><small> Contenido del informe. </small></p>
          </legend>

          <div class="row">
            <div class="col-12">
              <div class="form-group">
                <quill-editor
                  v-model="inputsInform.paragraph"
                  :options="editorOption"
                  :disabled="status"
                />
              </div>
            </div>
          </div>

          <hr />
          <br /><br />

          <button
            type="button"
            class="btn btn-primary"
            @click="enviar"
            v-if="!status"
          >
            Guardar
          </button>

  </div>
</div>

</div>
</template>

<script>
import { FormMixin } from "@/core/mixins/form/FormMixin.js";
import * as actions from "../../../../apiUrl";
import { quillEditor } from "vue-quill-editor";
import { axiosPost, axiosDelete } from "@/app/helpers/AxiosHelper";

export default {
  mixins: [FormMixin],
  components: { quillEditor },

  data() {
    return {
      isAddEditModalActive: false,
      deleteConfirmationModalActive: false,
      preloader: false,
      inputs: {},
      documents:"",
      inputsInform:{},
      dropzone_files_legal: [],
      contador: 0,
      deleteModal: false,
      selected: "",
       status: false,
      full_name_from: String,
      full_name_to: String,
      editorOption: {
        modules: {
          toolbar: [
            [{ size: ["small", false, "large", "huge"] }],
            ["bold", "italic", "underline"],
            [{ align: [] }],
            [{ indent: "-1" }, { indent: "+1" }],
            [{ color: [] }, { background: [] }],
            [{ list: "ordered" }, { list: "bullet" }],
            ["clean"],
          ],
        },
        theme: "snow", // or 'bubble'
      },
    };
  },

  created() {
    this.data();
  },

  filters: {
    dateFormat: function(value) {
      return moment(value).format("YYYY-MM-DD HH:mm");
    },
  },

  methods: {
    beforeSubmit() {
      this.preloader = true;
    },

    data() {
      let url = `${actions.EXECUTIVE_DIRECTOR}/directorLegalValidation/613/show?accAppId=${this.$store.state.accreditation.id}`;
      this.axiosGet(url).then((response) => {
        this.inputs = response.data;
      });
      let urlInfo = `${actions.TECHNICAL_ANALYSIS_REPORT}/generalTechnicalCoordination/generalTechnicalCoordinationReport/accreditationData/${this.$store.state.accreditation.id}`;
      this.axiosGet(urlInfo).then((resp) => {
        this.documents = resp.data.documents;
      });
            this.axiosGet(`/userInfo`).then((response) => {
        if (response.data) {
          this.user_id = response.data.id;
          this.full_name_from = response.data.full_name;
        }
      });


      this.axiosGet(`/technicalReport/${this.$store.state.accreditation.id}/613`)
        .then((response) => {
          if (response.status == 200 && response.data) {
            console.log(response);
            // verificar si ya se edito el pdf por el director de area.
            this.axiosGet(
              `/technicalReport/${this.$store.state.accreditation.id}/613`
            ).then((resp613) => {
                // this.$store.dispatch("getEvalTest");

              if (response.data.code_status != 613) {
                this.status = true; // Ocultar Procesar en otros estados posteriores.
              }else{
                this.status = false; // Ocultar Procesar en otros estados posteriores.
              }

              if (resp613.data.id) {
                            let date = new Date(resp613.data.report_date);
            date.setDate(date.getDate() + 1);
                this.inputsInform.from = this.user_id;
                this.inputsInform = resp613.data;
                this.inputsInform.id_technical_report =
                  resp613.data.id_technical_report;

                this.inputsInform.accreditation_id = this.$store.state.accreditation.id;
                this.inputsInform.report_date = new Date(date);

            this.receiver_id = resp613.data.juridical_data.id;

                this.full_name_to = resp613.data.full_name;
              } else {
                            let date = new Date(response.data.report_date);
            date.setDate(date.getDate() + 1);
                this.inputsInform.from = this.user_id;
                this.inputsInform = response.data;
                this.inputsInform.id_technical_report =
                  response.data.id_technical_report;

                this.inputsInform.accreditation_id = this.$store.state.accreditation.id;
                this.inputsInform.report_date = new Date(date);
                //this.inputs.report_date = new Date(date);
            this.receiver_id = response.data.juridical_data.id;

                this.full_name_to = response.data.full_name;
              }
            });
          }
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => {
          this.preloader = false;
        });


   
    },
    enviar() {
      this.inputsInform.accreditation_id = this.$store.state.accreditation.id;
      this.inputsInform.from = this.user_id;
      this.inputsInform.receiver = this.receiver_id;

      const d = this.inputsInform.report_date;
      this.inputsInform.report_date = [
        d.getFullYear(),
        d.getMonth() + 1,
        d.getDate(),
      ].join("-");

      let url = `/technicalReport/?actual_status=613`;

      let formData = new FormData();
      for (const [key, value] of Object.entries(this.inputsInform)) {
        formData.append(key, value);
      }
      //this.save(formData);

      axiosPost(url, formData)
        .then((res) => {

          if (res.status == 200) {
            this.$toastr.s("Registro guardado correctamente.");
          } else {
            this.$toastr.s("Error al registrar el informe.");
          }
          this.data();
        })
        .catch(({ error }) => {});

    },

    openModal(evaluation) {
      this.$store.state.qualityManagement.evaluation = evaluation;
      this.openAddEditModal();
    },

    openAddEditModal() {
      this.isAddEditModalActive = true;
    },

    closeAddEditModal() {
      this.isAddEditModalActive = false;
    },

    submit() {
      let formData = new FormData();
      for (const [key, value] of Object.entries(this.inputs)) {
        formData.append(key, value);
      }
      this.save(formData);
    },

    afterSuccess({ data: { data } }) {
      this.inputs = data;
      this.$toastr.s(this.$t("updated_success"));
    },

    afterFinalResponse() {
      this.preloader = false;
    },

    afterError(res) {
      this.$toastr.e(res.data.message);
    },

    openDeleteModal(fileName) {
      this.selected = fileName;
      this.deleteModal = true;
    },

    confirmed() {
      this.inputs[this.selected] = null;
    },

    cancelled() {
      this.deleteModal = false;
    },

    openTab(obj, fileName, key) {
      if (key) {
        const w = window.open(key, "_blank");
        w.focus();
      } else {
        const w = window.open(obj[fileName].path, "_blank");
        w.focus();
      }
    },

     openTabInfo(accAppId = this.$store.state.accreditation.id , status) {
      if (status == "605") {
        let path = `/evaluator/decision/closureFindingsDecision/view/${accAppId}?tab=Borrador del Informe Técnico`;
        window.open(path, "_blank").focus();
      }
      if (status == "608") {
        let path = `/accreditationReview/decision/areaDirectorReport/view/${accAppId}?tab=Anexos`;
        window.open(path, "_blank").focus();
      }
      if (status == "609") {
        let path = `/accreditationtechnical/generalTechnicalCoordination/generalTechnicalCoordinationReport/view/${accAppId}?tab=Evaluación%20/%20Testificación`;
        window.open(path, "_blank").focus();
      }
      if (status == "610") {
        let path = `/accreditationExecutive/legalValidation/610/view/${accAppId}?tab=Anexos`;
        window.open(path, "_blank").focus();
      }
      /* let path = `/evaluator/decision/closureFindingsDecision/view/${accAppId}?tab=Borrador del Informe Técnico`;
      window.open(path, "_blank").focus(); */
    },

  },
};
</script>
